import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { FormattedMessage } from 'LearningCenterUI/components/I18n'; // @ts-expect-error Could not find a declaration file for module

import ModalTile, { ModalTileSection } from './ModalTile';
import SectionHeading from '../../SectionHeading';
import FullWidthBackgroundColor from './FullWidthBackgroundColor';
import styled, { theme } from '../../../utils/Styling';
const DarkUITile = styled(ModalTile).withConfig({
  displayName: "OverviewModalCurriculumSection__DarkUITile",
  componentId: "sc-1pb3brp-0"
})(["color:", ";margin-top:0 !important;background-color:transparent;"], theme.colors.OLAF);

const OverviewModalCurriculumSection = ({
  children
}) => {
  return /*#__PURE__*/_jsxs(DarkUITile, {
    children: [/*#__PURE__*/_jsx(FullWidthBackgroundColor, {
      $color: "OBSIDIAN"
    }), /*#__PURE__*/_jsxs(ModalTileSection, {
      children: [/*#__PURE__*/_jsx(SectionHeading, {
        className: "m-bottom-4",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.overviewModal.curriculum"
        })
      }), children]
    })]
  });
};

export default OverviewModalCurriculumSection;